<template lang="pug">
    v-content
        v-toolbar(flat="" color="white")
            v-toolbar-title סנדי - WhatsApp
            v-divider.mx-2(inset="" vertical="")
            v-spacer
            v-dialog(v-model="userDialog" max-width="600px").rtl
                v-btn.mb-2(slot="activator" color="primary" dark="") user חדש
                v-card
                    v-card-title
                        span.headline {{ userFormTitle }}
                    v-card-text
                        v-container(grid-list-md="").rtl
                            v-layout(wrap="")
                                v-flex(xs12)
                                  v-text-field(reverse right v-model="userEditedItem.first_name" label="שם")
                                v-flex(xs12).ltr
                                  v-text-field(reverse left placeholder="972 52 111 2223" v-model="userEditedItem.phone" label="טלפון")
                                v-flex(xs12)
                                  v-text-field(reverse right v-model="userEditedItem.whatsapp_permissions" label="whatsapp_permissions")
                    v-card-actions
                        v-btn(color="green darken-1" flat="" @click="addUserToWhatsapp(userEditedItem)") שלח ליוזר הודעת איתחול
                        v-spacer
                        v-btn(color="blue darken-1" flat="" @click="close") Cancel
                        v-btn(color="blue darken-1" flat="" @click="saveUser(userEditedItem)") Save

            v-dialog(v-model="dialog" max-width="800px").rtl
                v-btn.mb-2(slot="activator" color="primary" dark="") בוט חדש
                v-card
                    v-card-title
                        span.headline {{ formTitle }}
                    v-card-text
                        v-container(grid-list-md="").rtl
                            v-layout(wrap="")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.name" label="שם הבוט")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.trigger" label="trigger (__trigger__)")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.description" label="תיאור")
                                v-flex(xs12).ltr
                                    v-textarea(solo v-model="editedItem.query" label="SQL")
                                v-flex(xs12).ltr
                                    v-text-field(reverse right v-model="editedItem.is_active" label="is_active")
                                v-flex(xs12).ltr
                                    v-text-field(reverse right v-model="editedItem.is_active_manipulations" label="is_active_manipulations")

                    v-card-actions
                        v-spacer
                        v-btn(color="blue darken-1" flat="" @click="close") Cancel
                        v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
        v-data-table#setting-table.elevation-1(
                :headers="headers"
                :items="entities"
                :loading='loading'
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
            )
            template(slot="items" slot-scope="props")
                td.text-xs-right {{ props.item.id }}
                td.text-xs-right {{ props.item.name }}

                td.justify-center.layout.px-0
                    v-icon.ml-4(small="" @click="deleteItem(props.item)") delete
                    v-icon.ml-4(small="" @click="editItem(props.item)") edit
                    v-tooltip.v-icon.ml-4(top)
                        v-icon(slot='activator' small @click="save(props.item, true)") repeat_one
                        span שכפל
</template>

<script>
    export default {
        data: () => ({
            sort_options_system: { ASC : 'ישר', DESC : 'הפוך' },
            sort_options: [{value : 'ASC', he_value : 'ישר'}, {value : 'DESC', he_value : 'הפוך'}],
            loading: true,
          userDialog: false,
            dialog: false,
            rowsPerPageItems: [10, 20, 50, 100, 1000],
            pagination: {
                rowsPerPage: 1000
            },
          // SELECT  'פסדר' as answer;
            headers: [
                // { text: 'id'                    , value: 'id'                               , sortable: false, align : 'right'},
                { text: 'trigger'            , value: 'trigger'                       , sortable: false, align : 'right' },
                { text: 'שם הבוט'            , value: 'name'                       , sortable: false, align : 'right' },
                { text: 'שאילתא'            , value: 'query'                       , sortable: false, align : 'right' },
                { text: 'תיאור'            , value: 'description'                       , sortable: false, align : 'right' },
                { text: 'פעיל'            , value: 'is_active'                       , sortable: false, align : 'right' },
                { text: 'פעיל מניפולציות'            , value: 'is_active_manipulations'                       , sortable: false, align : 'right' },
                { text: 'פעולות'                                                            , sortable: false, align : 'right' },
            ],
            entities: [],
            editedItem: {},
            userEditedItem: {
              whatsapp_permissions: "*"
            },
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'בוט חדש' : 'ערוך בוט'
            },
            userFormTitle () {
                return this.editedIndex === -1 ? 'יוזר חדש' : 'ערוך יוזר'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        created () {
          document.title = 'WhatsApp';

          this.$socket.on('*', (packet) => {

                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.initialize()
            this.$emit('update:loading', false)
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true)
            next();
        },

        methods: {
            range(first, last) {
                let a = first.charCodeAt(0)
                let b = last.charCodeAt(0) + 1
                return Array.apply(null, {length: Math.abs(b - a)})
                    .map(function (x,i) { return String.fromCharCode(Math.min(a, b) + i) });
            },

            initialize () {
                this.$socket.req('sendi.whatsapp.all', {user: this.$user}).then(data => {
                    this.entities = data.entities;
                        setTimeout(() => {
                            document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                            this.loading = false;
                        });
                });
            },

            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        // console.log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },

            editItem (item) {
              // const _item = (...item);
                this.editedIndex = this.entities.indexOf(item) || {};
                this.editedItem = { ...item };
                this.dialog = true
            },

            deleteItem (item) {
                confirm(`בטוח? למחוק את
                    ${item.name}
                `) && this.$socket.req('sendi.whatsapp.delete', {
                    id    : item.id
                }).then(() => {
                    this.initialize();
                });
            },


            close () {
                this.dialog = false
                this.userDialog = false
            },

            save (item, duplicate = false) {
              if (duplicate && !confirm('בטוח שאתה רוצה לשכפל את הבוט?')) {
                return;
              }
                if (duplicate) {
                  item = { ...item };
                  delete item['id'];
                  item['name'] = `(${item['name']})` + 'מסך חדש' + ' ' + Date.now();
                }

                this.loading = true;

                this.$socket.req('sendi.whatsapp.editOrAdd', item).then(data => {
                    let itemIdx = this.entities.findIndex(v => v.id === data.item.id);

                    if(itemIdx > -1) {
                        // this.entities[itemIdx] = data.item;
                        this.initialize();
                    }
                    else {
                        this.entities.push(data.item);
                    }
                    this.loading = false;
                    this.editedItem = {};
                });
                this.close();
            },

            saveUser(item) {
                this.loading = true;
                this.$socket.req('sendi.user.editOrAdd', item).then(data => {
                    this.entities.findIndex(v => v.id === data.item.id);
                    this.loading = false;
                    this.userEditedItem = {
                      whatsapp_permissions: "*"
                    };
                });
                this.close();
            },

          addUserToWhatsapp(item) {
                this.loading = true;
                this.$socket.req('sendi.user.addUserToWhatsapp', item).then(data => {
                    this.loading = false;
                    alert("נשלח")
                });
            },
        }
    }
</script>

<style lang="sass">
    #setting-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #setting-table .v-datatable.v-table
        direction: rtl

    #setting-table .v-datatable__actions
        direction: ltr


    .v-content__wrap
        background: #fff
    #setting-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px

    .v-tooltip.v-icon span
        display: inline-flex
</style>